import { useFormat } from '@ideavivat/vivat-2';

import { materialCode } from '@/table/PurchaseOrder/base';
import usePurchaseOrder from '@/use/usePurchaseOrder';
import { target_date, created_at } from './base';

const { statusClassMap, statusTranslate } = usePurchaseOrder();

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => statusTranslate(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return statusClassMap(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price);
        },
      },
    },
    // subType: {
    //   name: 'ประเภทงานจ้าง',
    //   width: '6rem',
    //   filter: (val: string, row: any) => {
    //     if (row.item.purchase_request.subType === 'CLAIM') return 'เคลม';
    //     if (row.item.purchase_request.subType === 'SURFACE_TREATMENT') return 'ชุบผิว';
    //     if (row.item.purchase_request.subType === 'HEAT_TREATMENT') return 'ชุบแข็ง';
    //     return '';
    //   },
    // },
    materialCode: {
      ...materialCode,
      width: '12rem',
    },
    material: {
      name: 'วัสดุ',
      width: '1fr',
      filter: (val: any, row: { item: any }) => `${row.item.material?.name || ''}`,
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      class: 'text-right mr-2',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filled_amount: {
    //   name: 'จำนวนที่ได้รับแล้ว',
    //   width: '8rem',
    //   filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    purchase_unit: {
      name: 'หน่วย',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any, row: { item: any }) => `${val ? val : row.item.material?.unit || ''}`,
    },
    target_date: {
      ...target_date,
      name: 'วันที่ส่งงานไปชุบ',
    },
    created_at: {
      ...created_at,
      name: 'วันที่ส่งงานกลับ',
    },
  },

};
